import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useMedia } from "react-use";
import { config as cssConfig } from "@100mslive/roomkit-react";
import { LogoIcon } from "../../icons";
import EventReplayChat from "./Chat";
import ReplayViewerPlayers from "./ReplayViewerPlayers";

const EventReplayLayout = props => {
  const {
    onRegister,
    userData,
    eventCover,
    replay,
    participants,
    eventId,
    hostedBy,
  } = props;
  const isMobile = useMedia(cssConfig.media.md);

  const videoRef = useRef(null);
  const [videoHeight, setVideoHeight] = useState(0);

  // Set chat height based on video height

  useEffect(() => {
    if (isMobile) return;
    const updateHeight = () => {
      if (videoRef.current) {
        const height = videoRef.current.offsetHeight;
        setVideoHeight(height);
      }
    };
    setTimeout(function () {
      updateHeight();
    }, 3000);
    setTimeout(function () {
      updateHeight();
    }, 1200);
    setTimeout(function () {
      updateHeight();
    }, 500);
    // Optional: Update on resize
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <React.Fragment>
      <div className="attendee-area-col-replay-layout-hostedBy">
        {hostedBy?.length > 0
          ? hostedBy.map((item, key) => {
              return (
                <Link
                  title={item?.orgName}
                  to={item?.orgSlug ? `/company/${item?.orgSlug}` : null}
                  key={key}
                  className="attendee-area-col-replay-layout-hostedBy-item"
                >
                  <div
                    className="attendee-area-col-replay-layout-hostedBy-logo"
                    style={{ backgroundColor: item?.orgLogoColor }}
                  >
                    {item?.orgLogo ? (
                      <img
                        src={item?.orgLogo}
                        alt={`Logo - ${item?.orgName} `}
                        width={50}
                        height={50}
                      />
                    ) : (
                      <LogoIcon />
                    )}
                  </div>
                  <div className="attendee-area-col-replay-layout-hostedBy-name">
                    {item?.orgName}
                  </div>
                </Link>
              );
            })
          : null}
      </div>
      <div className="attendee-area-col-replay-layout">
        <div className="attendee-area-col-replay-layout-video" ref={videoRef}>
          <ReplayViewerPlayers
            replayData={{
              poster: eventCover,
              replay: replay,
              autoPlay: userData && participants,
              overlay: !userData || !participants ? true : false,
            }}
            controllCallback={!userData || !participants ? onRegister : ""}
          />
        </div>

        <EventReplayChat
          chatHeight={videoHeight}
          userData={userData}
          eventId={eventId}
          onRegister={onRegister}
        />
      </div>
    </React.Fragment>
  );
};

export default EventReplayLayout;
